import { Row, SkeletonBox } from "@hightouch/htui";

const PLACEHOLDER_TILES = ["first", "second", "third", "fourth", "fifth"];

export const TilesSkeleton = () => (
  <Row gap={4} flexWrap="wrap">
    {PLACEHOLDER_TILES.map((tile) => (
      <SkeletonBox
        key={tile}
        height={20}
        flex="1"
        minWidth={24}
        borderRadius="xl"
      />
    ))}
  </Row>
);
